// Legacy entry point — converged onto the single DS renderer (CD-5256).
// Kept as a module so existing imports of 'Elements/TabListTable' keep working.
import TabListTable from './TabList/TabListTableFigma';

export default TabListTable;
